import React from "react";
import "../App.css"


function JoinButton(props) {
    return (
        <a href="https://discord.gg/2kQ94Nt5p7" target="_blank">
            <div className="joinour">
                <h4>{props.text}</h4>
            </div>
        </a>

    )
}
export default JoinButton;